import request from '@/utils/http.js';

// 获取观看有礼开关配置
const getWatchGiftConfig = params => {
  return request('/v3/webinars/watch-gift/get-config', {
    method: 'GET',
    params
  });
};

// 观看有礼开关设置
const switchWatchGift = params => {
  return request('/v3/webinars/watch-gift/switch', {
    method: 'POST',
    params
  });
};

// 获取观看有礼列表
const getWatchRewardList = params => {
  return request('/v3/vss/watch-gift/list', {
    method: 'GET',
    params
  });
};
const pushWatchReward = params => {
  return request('/v3/vss/watch-gift/push', {
    method: 'POST',
    data: params
  });
}
const endWatchReward = params => {
  return request('/v3/vss/watch-gift/end', {
    method: 'POST',
    data: params
  });
}

// 观看端/控制台-查询领奖配置
const getReceiveAwardSetting = params => {
  return request('/v3/vss/watch-gift/get-receive-award-setting', {
    method: 'GET',
    params
  });
}

// 观看端-获取当前直播最后一次推送的观看有礼信息
const getLastInfo = params => {
  return request('/v3/vss/watch-gift/get-last-info', {
    method: 'GET',
    params
  });
}


// 观看端--观众参与观看有礼
const participate = params => {
  return request('/v3/vss/watch-gift/participate', {
    method: 'GET',
    params
  });
}

// 观看端-查询用户中奖详情
const getWinnerDetail = params => {
  return request('/v3/vss/watch-gift/get-winner-detail', {
    method: 'GET',
    params
  });
}

// 观看端-观看有礼奖品列表
const getAwardList = params => {
  return request('/v3/vss/watch-gift/award/watch-list', {
    method: 'POST',
    data: params
  });
}

// 观看端-查询用户的中奖记录
const getWinnerList = params => {
  return request('/v3/vss/watch-gift/get-winner-list', {
    method: 'GET',
    params
  });
}

// 观看端-查询观看有礼的中奖名单
const getWinnerRank = params => {
  return request('/v3/vss/watch-gift/get-winner-rank', {
    method: 'GET',
    params
  });
}

// 观看端-获取领奖用户的信息（适用反显）
const getTakeAwardRemark = params => {
  return request('/v3/vss/watch-gift/get-take-award-remark', {
    method: 'GET',
    params
  });
}

//观看端-提交用户领奖信息
const saveTakeAwardRemark = params => {
  return request('/v3/vss/watch-gift/save-take-award-remark', {
    method: 'POST',
    data: params
  });
}
//发起端获取中奖用户列表
const getLiveWinnerList = params => {
  return request('/v3/vss/watch-gift/winner-record/list', {
    method: 'GET',
    params
  });
};

// 发起端-获取观看有礼详情
const requestInfo = params => {
  return request('/v3/vss/watch-gift/info', {
    method: 'GET',
    params
  });
};

// 发起端-创建观看有礼
const requestAdd = params => {
  return request('/v3/vss/watch-gift/add', {
    method: 'POST',
    data: params
  });
};

// 发起端-编辑观看有礼
const requestEdit = params => {
  return request('/v3/vss/watch-gift/edit', {
    method: 'POST',
    data: params
  });
};

// 发起端-复制观看有礼
const requestCopy = params => {
  return request('/v3/vss/watch-gift/copy', {
    method: 'POST',
    data: params
  });
};

// 发起端-删除观看有礼
const requestDelete = params => {
  return request('/v3/vss/watch-gift/batch-delete', {
    method: 'POST',
    data: params
  });
};


// 发起端-保存领奖页设置
const requestSaveReceiveSetting = params => {
  return request('/v3/vss/watch-gift/save-receive-award-setting', {
    method: 'POST',
    data: params
  });
};


// 发起端-获取领奖页设置
const requestGetReceiveSetting = params => {
  return request('/v3/vss/watch-gift/get-receive-award-setting', {
    method: 'GET',
    params
  });
};

// 发起端-获取奖池中奖品列表
const requestAwardListForLive = params => {
  return request('/v3/vss/watch-gift/award/list', {
    method: 'POST',
    data: params
  });
};

// 发起端-奖品列表排序
const requestSortAwardList = params => {
  return request('/v3/vss/watch-gift/award/sort', {
    method: 'POST',
    data: params
  });
};

export default {
  getWatchGiftConfig,
  switchWatchGift,
  getWatchRewardList,
  pushWatchReward,
  endWatchReward,
  getReceiveAwardSetting,
  getLastInfo,
  participate,
  getWinnerDetail,
  getWinnerList,
  getWinnerRank,
  getTakeAwardRemark,
  saveTakeAwardRemark,
  getAwardList,
  getLiveWinnerList,
  requestInfo,
  requestAdd,
  requestEdit,
  requestCopy,
  requestDelete,
  requestSaveReceiveSetting,
  requestGetReceiveSetting,
  requestAwardListForLive,
  requestSortAwardList
}